// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectSidebar__projectSidebar___0vS_u {
    --sidebar-width: 40rem;
    --radius: calc(2 * var(--control-radius));

    padding: 0 var(--space-s);
    border-radius: var(--radius) 0 0 var(--radius);
}

.ProjectSidebar__divider___rBskI {
    --delimiter-size: 100%;

    margin: var(--space-s) 0;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Main/ProjectsView/ProjectSidebar/ProjectSidebar.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,yCAAyC;;IAEzC,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,sBAAsB;;IAEtB,wBAAwB;AAC5B","sourcesContent":[".projectSidebar {\n    --sidebar-width: 40rem;\n    --radius: calc(2 * var(--control-radius));\n\n    padding: 0 var(--space-s);\n    border-radius: var(--radius) 0 0 var(--radius);\n}\n\n.divider {\n    --delimiter-size: 100%;\n\n    margin: var(--space-s) 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"projectSidebar": `ProjectSidebar__projectSidebar___0vS_u`,
	"divider": `ProjectSidebar__divider___rBskI`
};
export default ___CSS_LOADER_EXPORT___;
